import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import GetCustomerAgentsResult from "../classes/api/result/customeragentmodule/GetCustomerAgentsResult";
import GetCustomerAgentResult from "../classes/api/result/customeragentmodule/GetCustomerAgentResult";
import CreateOrUpdateCustomerAgentResult from "../classes/api/result/customeragentmodule/CreateOrUpdateCustomerAgentResult";
import DeleteCustomerAgentResult from "../classes/api/result/customeragentmodule/DeleteCustomerAgentResult";

import CustomerAgentListDto from "../classes/dtos/customeragentmodule/CustomerAgentListDto";
import CustomerAgentUsageDto from "../classes/dtos/customeragentmodule/CustomerAgentUsageDto";
import UserDto from "../classes/dtos/accountmodule/UserDto";
import DataSourceUsageDto from "../classes/dtos/datasourcemodule/DataSourceUsageDto";

const CustomerAgentApi = {

    GetCustomerAgentsAsync: async function (): Promise<ProcessingResult<GetCustomerAgentsResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerAgent/GetCustomerAgents", {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetCustomerAgentsResult(data.customerAgents.map((e: any) => new CustomerAgentListDto(e.id, e.name, e.roles, new UserDto(e.createdBy.id, e.createdBy.email, e.createdBy.firstName, e.createdBy.lastName), e.state, e.token))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetCustomerAgentByIdAsync: async function (id: number): Promise<ProcessingResult<GetCustomerAgentResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerAgent/GetCustomerAgentById?id=" + id.toString(), {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            let e = data.customerAgent;
            return ProcessingResult.Ok(new GetCustomerAgentResult(new CustomerAgentListDto(e.id, e.name, e.roles, new UserDto(e.createdBy.id, e.createdBy.email, e.createdBy.firstName, e.createdBy.lastName), e.state, e.token)));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateCustomerAgentAsync: async function (name: string, roles: number): Promise<ProcessingResult<CreateOrUpdateCustomerAgentResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerAgent/CreateCustomerAgent", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'name': name,
                'roles': roles
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateOrUpdateCustomerAgentResult(data.id, data.token));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateCustomerAgentAsync: async function (id: number, name: string, roles: number): Promise<ProcessingResult<CreateOrUpdateCustomerAgentResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerAgent/UpdateCustomerAgent", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'id': id,
                'name': name,
                'roles': roles
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateOrUpdateCustomerAgentResult(data.id, data.token));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteCustomerAgentAsync: async function (customerAgentId: number): Promise<ProcessingResult<DeleteCustomerAgentResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerAgent/DeleteCustomerAgent?customerAgentId=" + customerAgentId.toString(), {
            method: "Delete",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new DeleteCustomerAgentResult(data.deleted, data.usageDetails.map((e: any) => new CustomerAgentUsageDto(e.dataSourceId, e.dataSourceName, e.dataSourceType, e.dataSourceUsages.map((f: any) => new DataSourceUsageDto(f.pathId, f.pathName, f.pathType))))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default CustomerAgentApi;